import { environment } from '@/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { Especialidad } from '@/app/models/interface/especialidad.model';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class EspecialidadService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'especialidad/';

  create(data: Partial<Especialidad>) {
    return this.http.post<CustomResponse<Especialidad>>(this.url, data).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  findAll(params?: HttpParams) {
    return this.http
      .get<CustomResponse<PaginatorModel<Especialidad[], HasPagination>>>(
        this.url,
        {
          params,
        },
      )
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          if (d && Array.isArray(d.data)) {
            return {
              ...d,
              data: d.data.map((d) => ({
                ...d,
              })),
            };
          }
          return d;
        }),
      );
  }

  findOne(id: number) {
    const url = this.url + id;
    return this.http.get<CustomResponse<Especialidad>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  update(tipo: Partial<Especialidad>) {
    const url = this.url + tipo.id;
    return this.http.put<CustomResponse<Especialidad>>(url, tipo).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  changeState(state: boolean, id: number) {
    const url = this.url + id;
    return this.http.patch<CustomResponse<Especialidad>>(url, { state }).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }
}
